'use client';

interface SpotifyIconProps {
  width?: number;
  height?: number;
  color?: string;
}

const SpotifyIcon = ({ width = 24, height = 24, color = '#1DB954' }: SpotifyIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM16.586 16.424C16.432 16.68 16.108 16.764 15.852 16.608C13.296 15.044 10.096 14.7 6.536 15.516C6.248 15.58 5.96 15.4 5.896 15.112C5.832 14.824 6.012 14.536 6.3 14.472C10.172 13.584 13.68 13.976 16.508 15.712C16.764 15.868 16.848 16.192 16.692 16.448L16.586 16.424ZM17.812 13.656C17.62 13.976 17.212 14.08 16.892 13.888C13.984 12.104 9.528 11.596 6.22 12.544C5.856 12.656 5.472 12.448 5.36 12.084C5.248 11.72 5.456 11.336 5.82 11.224C9.588 10.148 14.476 10.716 17.772 12.744C18.092 12.936 18.196 13.344 18.004 13.664L17.812 13.656ZM17.908 10.776C14.428 8.712 8.948 8.512 5.776 9.468C5.336 9.6 4.872 9.348 4.74 8.908C4.608 8.468 4.86 8.004 5.3 7.872C8.952 6.776 15.012 7.012 19.004 9.376C19.4 9.612 19.532 10.128 19.296 10.524C19.06 10.92 18.544 11.052 18.148 10.816L17.908 10.776Z"
        fill={color}
      />
    </svg>
  );
};

export default SpotifyIcon;
